/* eslint-disable no-restricted-syntax */ const { hasOwnProperty } = Object.prototype;
function qsNull(value, prefix, buffer) {
    if (value === undefined) {
    // `undefined` does not serialize the parameter at all.
    } else if (value === null) {
        buffer.push(`${encodeURIComponent(prefix)}`);
    }
}
function qsNonNull(value, prefix, buffer) {
    buffer.push(`${encodeURIComponent(prefix)}=${encodeURIComponent(value)}`);
}
function qsArray(value, prefix, buffer) {
    const length = value.length;
    for(let key = 0; key < length; key++){
        if (hasOwnProperty.call(value, key)) {
            const item = value[key];
            if (item == null || typeof item !== 'object') {
                qsGeneric(item, `${prefix}[]`, buffer);
            } else {
                qsGeneric(item, `${prefix}[${key}]`, buffer);
            }
        }
    }
}
function qsObject(value, prefix, buffer) {
    for(const key in value){
        if (hasOwnProperty.call(value, key)) {
            qsGeneric(value[key], `${prefix}[${key}]`, buffer);
        }
    }
}
function qsGeneric(value, prefix, buffer) {
    if (value == null) {
        qsNull(value, prefix, buffer);
    } else if (Array.isArray(value) || value instanceof Array) {
        qsArray(value, prefix, buffer);
    } else if (typeof value === 'object') {
        qsObject(value, prefix, buffer);
    } else {
        qsNonNull(value, prefix, buffer);
    }
}
export default function stringify(value) {
    const buffer = [];
    for(const key in value){
        if (value.hasOwnProperty(key)) {
            qsGeneric(value[key], key, buffer);
        }
    }
    return buffer.join('&');
}

//# sourceMappingURL=stringify.js.map